export default __webpack_public_path__ + "static/media/solidrums3.fef946e4.png";